import { createContextReducer } from "../../common/helpers/createContextReducer";
import { Nullable } from "../../common/types/types";
import { getStallMode, initialState } from "./constants";
import { APP_MODE, IAppConfig, IConfigState, ILocation, IQrSession, IStallMode, IPaymentMethodEntry } from "./types";

const ConfigReducer = {
	SET_CATALOGUE_DATA: (state: IConfigState, data: ILocation) => {
		state.location = data;
	},
	SET_STALL_MODE: (state: IConfigState, appMode: IStallMode) => {
		state.stallMode = appMode;
	},
	SET_APP_MODE: (state: IConfigState, appMode: APP_MODE) => {
		state.appMode = appMode;
	},
	SET_SESSION: (state: IConfigState, { session_id }: { session_id: string }) => {
		state.user.session_id = session_id;
	},
	SET_PAYMENT_METHODS: (state: IConfigState, methods: IPaymentMethodEntry[]) => {
		state.paymentMethods = methods ?? [];
	},
	INIT_CONFIG: (state: IConfigState, data: IAppConfig) => {
		state.config = data;
		state.inited = true;
		state.config.bcrs_deposit_rate = data.bcrs_deposit_rate ?? 10;
		state.stallMode = getStallMode(data.stall.mode);
		state.location = { id: state.location.id, name: data.stall.name };
	},
	INIT_LOCATION_ID_AND_TABLE: (
		state: IConfigState,
		{ location_id, table }: { location_id: string; table: Nullable<string> }
	) => {
		state.location = {
			...state.location,
			id: location_id,
		};
		state.table = table;
	},
	SET_QR_SESSION: (state: IConfigState, qrSession: IQrSession) => {
		state.qrSession = qrSession;
		state.table = qrSession.table;
	},
};

const {
	AppProvider: ConfigProvider,
	useContextActions: useConfigActions,
	useContextPartial: useConfigContext,
} = createContextReducer(initialState, ConfigReducer);

export { ConfigProvider, useConfigActions, useConfigContext };
